/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import { useEffect, useState, useRef } from 'react'
import NavbarTopAdmin from '../../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../../admin/components/navbarBottomAdmin'
import NavbarNotAuth from '../../../userNotAuth/components/navbarNotAuth'
import { useNavigate, useLocation } from 'react-router-dom'
import AuthProvider from '../../../Authentication/authProvider'
import axios from 'axios'
import DivBottom from '../../../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"
import { useLoadScript } from '@react-google-maps/api'  // converte da comune a coordinate lat e lng per google mapsaps

const LIBRARIES = ['places'] // per google maps

let error = []//array gestione errori insert foto
let error2 = []//array gestione errori insert foto menù
let tipoCucinaArr = []
let filter = []// array per visualizzare le città in base all'input dell'utente

function EditRisto() {
    const navigate = useNavigate(); const location = useLocation()
    const { isLoaded } = useLoadScript({ // COSTRUTTORE GOOGLE MAPS
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS,
        LIBRARIES // Aggiungi libraries se necessario
    })
    let risto = location.state?.risto
    if (risto === undefined) {//se NON provengo da profiloRistorante
        risto = { img: '' }; navigate("/")//evito l'errore in img.split
    }

    function createArrImgOld() {//funzione per visualizzare le foto archiviate in MYSQL 
        let arrImg = [], arrImgName = [], arrImgMenù = []
        if (risto.img) {//se ci sono foto in MYSQL caricale in 'setFoto' per mandarle a schermo

            risto.img.split(',').forEach((item, index) => {
                if (item.includes('menù')) {
                    arrImgMenù.push(item)
                } else {
                    arrImg.push(item)
                    arrImgName[index] = { name: item }
                }
            })
        }; return { arrImg: arrImg, arrImgName: arrImgName, arrImgMenù: arrImgMenù }
    }
    const oldImg = createArrImgOld()

    const [formData, setFormData] = useState({
        descrizione: risto.descrizione,
        email: risto.emailUser,
        indirizzo: risto.soggetto,
        nome: risto.nome,
        fb: risto.fb,
        città: risto.città,
        idUser: localStorage.getItem('id'),
        comune: risto.regione,
        telefono: risto.telefono,
        tipoCucina: [],
        url: risto.url,
        youtube: risto.youtube,
        video: risto.video
    })
    const [msg, setMsg] = useState({ foto: null, telefono: null, email: null, msgCittà: '' })//messaggio email non valida
    const [msgMenù, setMsgMenù] = useState({ foto: null })
    const [foto, setFoto] = useState(oldImg.arrImg)
    const [fotoMenù, setFotoMenù] = useState(oldImg.arrImgMenù)
    const [caricamento, setCaricamento] = useState(null)
    const [caricamento2, setCaricamento2] = useState(null)
    const [msgProgress, setMsgProgress] = useState({ string: null, failed: null, submit: null })//barra del loader dopo submit 
    const [cityFilter, setCityFilter] = useState(null)//città filtrate ad ogni change dell'input 'città'

    const numFoto = [0, 1, 2] // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------
    const numFotoMenù = [0, 1, 2] // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------
    const città = ['Agrigento', 'Alessandria', 'Ancona', 'Aosta', 'Aquila', 'Arezzo', 'Ascoli Piceno', 'Asti', 'Avellino',
        'Bari', 'Barletta-Andria-Trani', 'Belluno', 'Benevento', 'Bergamo', 'Biella', 'Bologna', 'Bolzano', 'Brescia', 'Brindisi',
        'Cagliari', 'Caltanissetta', 'Campobasso', 'Carbonia', 'Caserta', 'Catania', 'Catanzaro', 'Chieti', 'Como', 'Cosenza', 'Cremona', 'Crotone', 'Cuneo',
        'Enna',
        'Fermo', 'Ferrara', 'Firenze', 'Foggia', 'Forlì e Cesena', 'Frosinone',
        'Genova', 'Gorizia', 'Grosseto',
        'Imperia', 'Isernia',
        'La Spezia', 'Latina', 'Lecce', 'Lecco', 'Livorno', 'Lodi', 'Lucca',
        'Macerata', 'Mantova', 'Massa-Carrara', 'Matera', 'Messina', 'Milano', 'Modena', 'Monza',
        'Napoli', 'Novara', 'Nuoro',
        'Oristano',
        'Padova', 'Palermo', 'Parma', 'Pavia', 'Perugia', 'Pesaro e Urbino', 'Pescara', 'Piacenza', 'Pisa', 'Pistoia', 'Pordenone', 'Potenza', 'Prato',
        'Ragusa', 'Ravenna', 'Reggio Calabria', 'Reggio Emilia', 'Rieti', 'Rimini', 'Roma', 'Rovigo',
        'Salerno', 'Sassari', 'Savona', 'Siena', 'Siracusa', 'Sondrio',
        'Taranto', 'Teramo', 'Terni', 'Torino', 'Trapani', 'Trento', 'Treviso', 'Trieste',
        'Udine',
        'Varese', 'Venezia', 'Verbano', 'Vercelli', 'Verona', 'Vibo Valentia', 'Vicenza', 'Viterbo']

    const descrizione = useRef()
    const telefono = useRef()
    const altro = useRef()// altra specialità in options
    const cittàValue = useRef()
    const cityFilterId = useRef()//per display 'block' o 'none' del div delle città selezionabili
    const divSuccess = useRef()
    const bodyId = useRef()

    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        if (!formData.città || msg.msgCittà) {
            window.scrollTo(0, 100); return
        }
        else
            if (formData.telefono && /^[0-9\s-]+$/.test(formData.telefono) === false) {
                setMsg({ ...msg, telefono: '*** Campo numerico ***' }); window.scrollTo(0, 750)
                telefono.current.style.border = '1px solid red'; return
            } else
                if (formData.email) {
                    const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                    if (!validRegex.test(formData.email)) {
                        setMsg({ ...msg, email: '*** email non valida ***' }); window.scrollTo(0, 700); return
                    }
                }
        // // ---------------- SE TUTTO E' IN CHECK --------------------
        setMsgProgress({ submit: 'Caricamento in corso...' })
        // ---------------- OTTENGO LAT E LNG DEL RISTORANTE --------
        const address = formData.indirizzo + ' ' + formData.comune + ' ' + ' ' + formData.città
        if (isLoaded) {
            const geocoder = new window.google.maps.Geocoder()
            geocoder.geocode({ address: address }, async (results, status) => {// geocodifica, da indirizzo a latitudine e longitudine
                if (status === "OK") {
                    const lat = results[0].geometry.location.lat()
                    const lng = results[0].geometry.location.lng()
                    const object = { ...formData, foto: foto, fotoMenù: fotoMenù, lat: lat, lng: lng }
                    try {//chiamata a server per insert in mysql del foodTruck creato
                        const res = await axios.post(`/updateRisto/${risto.id}`, object)
                        if (res.data === 'Success') {
                            setTimeout(() => {
                                setMsgProgress({ string: null })
                                divSuccess.current.style.display = 'block'
                            }, 1500)
                        }
                    } catch (err) { setMsgProgress({ string: '*** Modifica ristorante fallito...riprova', submit: null }); console.error(err); return }
                } else {
                    console.error("Geocoding failed: " + status)
                }
            })
        }
    }
    function handleChange(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        setMsg({ ...msg, email: null, telefono: null }); setMsgProgress({ failed: null })
        descrizione.current.style.border = '1px solid black'; telefono.current.style.border = '1px solid black'

        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setMsg({ ...msg, telefono: '*** Campo numerico ***' }) }
        }
        if (name === 'specialità' && value === 'Altro') {
            altro.current.style.display = 'block'
        } else
            if (name === 'specialità' && value !== 'Altro' && altro.current.style.display === 'block') {
                altro.current.style.display = 'none'
            }
        if (name === 'altro') setFormData({ ...formData, specialità: inputValue })
    }
    const imageChange = async (e) => {
        if (e.target.files[0]) {
            const el = e.target.getAttribute('data-val')//posizione della foto in array 'foto'
            const eT = e.target.files[0]
            if (eT.type.startsWith('image/')) {
                setCaricamento('Caricamento in corso...'); setMsgProgress({ failed: null })
                error = []
                setMsg(error)

                // RINOMINAZIONE FOTO CON NOME RANDOM
                let extens = eT.name.substring(eT.name.lastIndexOf('.') + 1)// ricavo l'estensione
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                let result = ''
                const charactersLength = characters.length
                for (let i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength))
                }
                const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto

                // ------ ACCETTAZIONE IMMAGINE ----------------------------------------                 
                try {
                    const fd = new FormData()
                    fd.append('foto', eT); fd.append('nomeFoto', zxc); fd.append('stato', 'siAwsBucket')
                    const res = await axios.post('/convertJpegBase64', fd, {
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                    if (res.data === 'success') {
                        setFoto(foto.concat(`ZE_${result}.webp`))//per preview 
                        setCaricamento(null)
                        document.getElementById('labelAll' + el).style.display = 'none'// tolgo '+foto'
                        el < numFoto.length - 1 && ( //risettaggio input disabled = false
                            document.getElementById('upload-photo' + (parseInt(el) + 1)).disabled = false)
                    } else {//upload foto failed
                        document.getElementById('upload-photo' + el).value = ''
                        setCaricamento('*** problemi con il server...riprova ***')
                    }
                } catch (err) { console.log(err) }

            } else {
                //immagine type non conforme
                error[el] = 'Tipo immagine non conforme'
                // setMsg(error)
                e.target.value = ""; return
            }
        }
    }
    const imageMenùChange = async (e) => {
        if (e.target.files[0]) {
            const el = e.target.getAttribute('data-val')//posizione della foto in array 'foto'
            const eT = e.target.files[0]
            if (eT.type.startsWith('image/')) {
                setCaricamento2('Caricamento in corso...'); setMsgProgress({ failed: null })
                error2 = []
                setMsgMenù(error2)

                // RINOMINAZIONE FOTO CON NOME RANDOM
                let extens = eT.name.substring(eT.name.lastIndexOf('.') + 1)// ricavo l'estensione
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                let result = ''
                const charactersLength = characters.length
                for (let i = 0; i < 11; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength))
                }
                const zxc = `ZEmenù_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto

                // ------ ACCETTAZIONE IMMAGINE ----------------------------------------                 
                try {
                    const fd = new FormData()
                    fd.append('foto', eT); fd.append('nomeFoto', zxc); fd.append('stato', 'siAwsBucket')
                    const res = await axios.post('/convertJpegBase64', fd, {
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                    if (res.data === 'success') {
                        setFotoMenù(fotoMenù.concat(`ZEmenù_${result}.webp`))//per preview 
                        setCaricamento2(null)
                        document.getElementById('labelAll2' + el).style.display = 'none'// tolgo '+foto'
                        el < numFoto.length - 1 && ( //risettaggio input disabled = false
                            document.getElementById('upload-photo2' + (parseInt(el) + 1)).disabled = false)
                    } else {//upload foto failed
                        document.getElementById('upload-photo2' + el).value = ''
                        setCaricamento2('*** problemi con il server...riprova ***')
                    }
                } catch (err) { console.log(err) }

            } else {
                //immagine type non conforme
                error2[el] = 'Tipo immagine non conforme'
                setMsgMenù(error2)
                e.target.value = ""; return
            }
        }
    }
    const imageRemove = async (e) => {
        setMsg({ ...msg, foto: null }); error = []
        const el = e.target.getAttribute("data-val")//posizione della foto da eliminare in array 'foto'
        document.getElementById('upload-photo' + el).value = ''
        const bj = foto.length - 1

        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                const nj = [...foto]
                nj.splice(el, 1)
                setFoto(nj)
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('labelAll' + bj).style.display = 'block'//visualizzo '+foto'  
                }, 50)
            }, speed)
        }

        try {
            axios.delete(`/delete-img/${foto[el]}`)
        } catch (err) { setCaricamento('*** Problemi con la connessione ***'); console.error(err); return }
        removeFadeOut(document.getElementById('preview' + el), 200)
        removeFadeOut(document.getElementById('iconaElimina' + el), 200)
        //RISETTAGGIO INPUT FOTO = DISABLED
        let index = foto.length - 1
        for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
            if (h > (index + 1)) {
                document.getElementById('upload-photo' + (h - 1)).disabled = true
            }
        }
    }
    const imageMenùRemove = async (e) => {
        setMsgMenù({ ...msgMenù, foto: null }); error2 = []
        const el = e.target.getAttribute("data-val")//posizione della foto da eliminare in array 'foto'
        document.getElementById('upload-photo2' + el).value = ''
        const bj = fotoMenù.length - 1

        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                const nj = [...fotoMenù]
                nj.splice(el, 1)
                setFotoMenù(nj)
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('labelAll2' + bj).style.display = 'block'//visualizzo '+foto'  
                }, 50)
            }, speed)
        }

        try {
            axios.delete(`/delete-img/${fotoMenù[el]}`)
        } catch (err) { setCaricamento('*** Problemi con la connessione ***'); console.error(err); return }
        removeFadeOut(document.getElementById('preview2' + el), 200)
        removeFadeOut(document.getElementById('iconaElimina2' + el), 200)
        //RISETTAGGIO INPUT FOTO = DISABLED
        let index = fotoMenù.length - 1
        for (let h = 1; h <= numFotoMenù.length; h++) {//loop di tutti i div contenenti gli input type file
            if (h > (index + 1)) {
                document.getElementById('upload-photo2' + (h - 1)).disabled = true
            }
        }
    }
    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {// video conforme
                if (ETarget.size > 100000000) {
                    setMsgProgress({ ...msgProgress, string: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                document.getElementById('rotaryVideo').style.display = 'block'
                setMsgProgress({ ...msgProgress, string: 'Attendere...upload video in corso' })
                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setMsgProgress({ ...msgProgress, string: '*** Video troppo lungo (max 5 min) ***' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'

                    } else {// ------ ACCETTAZIONE VIDEO ----------------------------------------   
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}`// aggiungo ZE alla stringa random che darà il nome al video
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setMsgProgress({ ...msgProgress, string: 'Video caricato con successo' })
                            setFormData({ ...formData, video: videoName }) //formData.video è il nome che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setMsgProgress({ ...msgProgress, string: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {
                //video type non conforme
                setMsgProgress({ ...msgProgress, string: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData({ ...formData, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }

        try {
            axios.delete(`/delete-video/${formData.video}`)
        } catch (err) { setMsgProgress({ ...msgProgress, string: '*** Problemi con la connessione ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setMsgProgress({ ...msgProgress, string: null })
    }
    function handleTipoCucina(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        if (inputValue === true) {
            tipoCucinaArr.push(name)
        } else
            if (inputValue === false) {
                tipoCucinaArr = tipoCucinaArr.filter(item => item !== name)
            }
        setFormData({ ...formData, [name]: inputValue, tipoCucina: tipoCucinaArr })
    }
    function handleChangeCittà(e) {
        const { value } = e.target
        filter = []
        città.forEach((elem, index) => {//filtraggio città da input 'città'
            if (value !== '') {
                let result = elem.substring(0, value.length)//se scrivo anc viene intercettato l'elemento 'Ancona' in città[]
                if (result.toLowerCase() === value.toLowerCase()) {//match tra input 'città' e array città
                    filter.push(elem)
                }
            }
        })
        if (filter.length > 0) {//se in input 'città' viene trovata una città in array 'citta'
            setCityFilter(filter)
            setMsg({ ...msg, msgCittà: null })
            cityFilterId.current.style.display = 'block'
        } else {
            cityFilterId.current.style.display = "none"
            setMsg({ ...msg, msgCittà: 'Città non trovata' })
        }
    }
    const cittàCliccata = (elem) => {//porta in input 'cittàValue' la città che clicchiamo dalla lista delle città
        cittàValue.current.value = elem
        setFormData({ ...formData, città: elem })
        setCityFilter(null); cityFilterId.current.style.display = 'none'
    }

    useEffect(() => {// settaggio input disabled
        if (foto.length < numFoto.length - 1) {
            let fotoLength = foto.length;
            for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input 'foto'
                if (h > (fotoLength + 1)) {
                    document.getElementById('upload-photo' + (h - 1)).disabled = true
                }
            }
        }
        if (fotoMenù.length < numFotoMenù.length - 1) {
            let fotoLength = fotoMenù.length;
            for (let h = 1; h <= numFotoMenù.length; h++) {//loop di tutti i div contenenti gli input 'fotoMenù'
                if (h > (fotoLength + 1)) {
                    document.getElementById('upload-photo2' + (h - 1)).disabled = true
                }
            }
        }
        if (foto.length !== 0) { // settaggio label dentro il div dell'input delle foto (+foto)
            for (let x = 0; x < foto.length; x++) {
                document.getElementById('labelAll' + x).style.display = 'none'
            }
        }
        if (fotoMenù.length !== 0) { // settaggio label dentro il div dell'input delle fotoMenù (+foto)
            for (let x = 0; x < fotoMenù.length; x++) {
                document.getElementById('labelAll2' + x).style.display = 'none'
            }
        }
        // console.log('foto:', foto)
    }, [foto, fotoMenù])

    useEffect(() => {
        document.body.style.overflow = "scroll"
        window.scrollTo(0, 0)
        if (risto.genere) {//settaggio TIPO CUCINA
            tipoCucinaArr = risto.genere.split(',')

            let reg = [false, false, false, false, false]
            tipoCucinaArr.forEach((elem, index) => {
                switch (elem) {
                    case 'italiana': reg[0] = true; break
                    case 'hamburger': reg[1] = true; break
                    case 'etnica': reg[2] = true; break
                    case 'vegetariana': reg[3] = true; break
                    case 'vegana': reg[4] = true; break
                }
            })
            setFormData({//settaggio checkbox
                ...formData,
                italiana: reg[0],
                hamburger: reg[1],
                etnica: reg[2],
                vegetariana: reg[3],
                vegana: reg[4],
            })
        }
        if (risto.video) {
            document.getElementById('lblVideo').style.display = 'none' // +video
            document.getElementById('upload-video').disabled = false
        }
        cittàValue.current.addEventListener('change', () => {
            bodyId.current.addEventListener('mouseup', onMouseUp)
            function onMouseUp() {//gestione input 'cittàValue' al click nel body del documento    
                if (formData.città || cityFilterId.current.style.display === "block") {
                    cittàValue.current.value = formData.città
                    cityFilterId.current.style.display = "none"
                    bodyId.current.removeEventListener('mouseup', onMouseUp)
                }
            }
        })
    }, [])

    // useEffect(() => { console.log('formData:', formData) }, [formData])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}

        <div ref={bodyId} className='container' style={{ marginBottom: '3rem', marginTop: '6rem' }}>
            <h2 className='bg-primary p-2 text-light mt-3' style={{ clear: 'right' }}>Modifica il Ristorante</h2>

            <form className='mt-5' onSubmit={handleSubmit}>
                <div className="col-md-6"></div>

                <div> {/* ----------------- nome --------------- */}
                    <label htmlFor='nome'>Nome Ristorante *</label>
                    <input className="form-control fw-bold"
                        name="nome"
                        defaultValue={formData.nome}
                        maxLength={45}
                        onChange={handleChange}
                        required
                        type="text" />
                </div>

                <div> {/* --------------- città ----------------------- */}
                    <label htmlFor='città' className='mt-4'>Città (provincia)*</label>
                    <input className="form-control fw-bold" style={{ width: '50%' }}
                        name="città" ref={cittàValue}
                        defaultValue={formData.città}
                        maxLength={45}
                        onChange={handleChangeCittà}
                        required
                        type="text" />

                    <div ref={cityFilterId} style={{
                        border: '1px solid black', padding: '5px', margin: '5px', overflow: 'auto', position: 'absolute', width: '20rem',
                        display: 'none', backgroundColor: 'whitesmoke'
                    }}>
                        {cityFilter &&
                            cityFilter.map((elem, index) => (
                                <span className='filterCity' key={index}>
                                    <p style={{ fontFamily: 'sans-serif', cursor: 'pointer' }} onClick={() => { cittàCliccata(elem) }}>{elem}
                                    </p>
                                </span>
                            ))
                        }
                    </div>
                    {msg.msgCittà && <p style={{ color: 'red' }}>{msg.msgCittà}</p>}
                </div>

                <div> {/*Comune*/}
                    <label htmlFor='comune'>Località (comune)*</label>
                    <input className="form-control fw-bold"
                        defaultValue={formData.comune} id="comune"
                        name='comune'
                        onChange={handleChange}
                        required
                        maxLength={35}
                        type='text' />
                </div>

                <div> {/*Indirizzo*/}
                    <label htmlFor='indirizzo' className='mt-4'>Indirizzo/Indicazioni *</label>
                    <input className="form-control fw-bold"
                        defaultValue={formData.indirizzo} id="indirizzo"
                        name='indirizzo' required
                        onChange={handleChange}
                        maxLength={50}
                        placeholder='Es. piazza Cavour'
                        type='text' />
                    {msg.msgIndirizzo && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgIndirizzo}</i></p>}
                </div>

                <div> {/* ------------------ TIPO CUCINA --------------- */}
                    <h5 style={{ marginTop: '1rem' }}>TIPO DI CUCINA<span className='ms-3 fs-6'><i>(facoltativo)</i></span></h5>
                    <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 1fr', gap: '4px' }}>
                        <div><input type='checkbox'
                            name='italiana'
                            checked={formData.italiana}
                            onChange={handleTipoCucina} />
                        </div>
                        <div>Cucina italiana tradizionale</div>

                        <div><input type='checkbox'
                            name='hamburger'
                            checked={formData.hamburger}
                            onChange={handleTipoCucina} />
                        </div>
                        <div>Hamburger & Fast Food</div>

                        <div><input type='checkbox'
                            name='etnica'
                            checked={formData.etnica}
                            onChange={handleTipoCucina} />
                        </div>
                        <div>Etnica/Internazionale</div>

                        <div><input type='checkbox'
                            name='vegetariana'
                            checked={formData.vegetariana}
                            onChange={handleTipoCucina} />
                        </div>
                        <div>Vegetariana</div>

                        <div><input type='checkbox'
                            name='vegana'
                            checked={formData.vegana}
                            onChange={handleTipoCucina} />
                        </div>
                        <div>Vegana</div>
                    </div>
                </div>

                <div> {/* --------------- descrizione --------------- */}
                    <h4 style={{ marginTop: '3rem' }}>Descrivi la tua attività<span className='fs-6 ms-2'> <i>(facoltativo)</i></span></h4>
                    <p><i style={{ color: 'marron' }}>Ad esempio qualche particolare importante delle tue offerte gastronomiche...</i></p>
                    <textarea style={{ padding: '5px' }} className='form-control' ref={descrizione} value={formData.descrizione}
                        name="descrizione"
                        rows='10'
                        maxLength={2000}
                        onChange={handleChange}
                    >
                    </textarea>
                </div>

                <div> {/* ---------------- telefono --------------- */}
                    <label htmlFor='telefono' className='mt-3'>Telefono </label>
                    <input className='form-control fw-bold' style={{ width: '50%' }} ref={telefono}
                        name='telefono'
                        defaultValue={formData.telefono}
                        maxLength={20}
                        onChange={handleChange}
                        type='text' />
                    {msg.telefono && <p style={{ color: 'red' }}><i>{msg.telefono}</i></p>}
                </div>

                <div> {/* -------------------------- Email -------------------- */}
                    <label htmlFor='form-control fw-bold'>Email</label>
                    <input className="form-control fw-bold" id="email"
                        name='email'
                        defaultValue={formData.email}
                        onChange={handleChange}
                        type='text' />
                    {msg.email && <p style={{ color: 'red' }}>{msg.email}</p>}
                </div>

                {/* ----------- LINK ------------- */}
                <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                <div style={{ marginLeft: '1rem' }}>
                    <label htmlFor='email' className='mt-1'>URL sito web</label>
                    <input className="form-control fw-bold"
                        name="url"
                        defaultValue={formData.url}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.zona-eventi.it/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL Facebook</label>
                    <input className="form-control fw-bold"
                        name="fb"
                        defaultValue={formData.fb}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.facebook.com/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL Instagram</label>
                    <input className="form-control fw-bold"
                        name="youtube"
                        defaultValue={formData.youtube}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.instagram.com/'
                        type="text" />
                </div>

                {/* ------------------------ aggiungi immagini ------------------------- */}
                <h4 style={{ marginTop: '3rem' }}>AGGIUNGI IMMAGINI <span className='fs-6 ms-1'>(facoltativo)</span></h4>
                <p className='ms-3 text-success'><i>Aggiungi immagini del tuo ristorante</i></p>
                <div className='gridAddEvento2 mt-5'>
                    {numFoto.map(elem => (
                        <div key={elem} className='fotoEvento'>
                            <label htmlFor={"upload-photo" + elem} style={{ cursor: 'pointer' }} id={'labelAll' + elem}>
                                {elem === 0 ? <span style={{ fontSize: 'small' }}>+ Foto principale</span> : <span>+foto</span>}
                            </label>
                            {foto[elem] && //preview
                                <div>
                                    <div style={{ marginTop: '-25px' }}>
                                        <button style={{ marginLeft: '5rem', border: 'transparent', backgroundColor: 'transparent' }} data-val={elem}
                                            onClick={imageRemove} id={'iconaElimina' + elem} type='button'>
                                            ❌
                                        </button>
                                    </div>
                                    <span id={'preview' + elem}>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${foto[elem]}`} style={{ maxWidth: '100px', height: '74px' }} alt="" />
                                    </span>
                                </div>
                            }
                            {error[elem] &&
                                <p id={'msg' + elem} style={{ fontSize: 'small', opacity: '.7' }}>{msg[elem]}</p>
                            }
                            <input id={'upload-photo' + elem} style={{ opacity: '0', fontSize: '0px' }}
                                type='file' data-val={elem}
                                name={'foto' + elem}
                                accept="image/*"
                                onChange={imageChange} />
                        </div>
                    ))}
                    <div className='mt-1' style={{ color: 'red' }}>
                        {caricamento}
                        {caricamento === 'Caricamento in corso...' &&
                            <RotatingLines strokeColor='red' strokeWidth='5' animationDuration='5' width='26' />
                        }
                    </div><br /><br />
                </div><hr />

                <p className='ms-3 text-primary'><i>Aggiungi immagini del menù</i></p>
                <div className='gridAddEvento2 mt-5'>
                    {numFotoMenù.map(elem => (
                        <div key={elem + 'menù'} className='fotoEvento' style={{ borderRadius: '7px' }}>
                            <label htmlFor={"upload-photo2" + elem} style={{ cursor: 'pointer' }} id={'labelAll2' + elem}>
                                {elem === 0 ? <span style={{ fontSize: 'small' }}>+ Foto principale</span> : <span>+foto</span>}
                            </label>
                            {fotoMenù[elem] && //preview
                                <div>
                                    <div style={{ marginTop: '-25px' }}>
                                        <button style={{ marginLeft: '5rem', border: 'transparent', backgroundColor: 'transparent' }} data-val={elem}
                                            onClick={imageMenùRemove} id={'iconaElimina2' + elem} type='button'>
                                            ❌
                                        </button>
                                    </div>
                                    <span id={'preview2' + elem}>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${fotoMenù[elem]}`} style={{ maxWidth: '100px', height: '74px', borderRadius: '7px' }} />
                                    </span>
                                </div>
                            }
                            {error2[elem] &&
                                <p id={'msgMenù' + elem} style={{ fontSize: 'small', opacity: '.7' }}>{msgMenù[elem]}</p>
                            }
                            <input id={'upload-photo2' + elem} style={{ opacity: '0', fontSize: '0px' }}
                                type='file' data-val={elem}
                                name={'fotoMenù' + elem}
                                accept="image/*"
                                onChange={imageMenùChange} />
                        </div>
                    ))}
                </div>

                <div className='mt-1' style={{ color: ' red' }}>
                    {caricamento2}
                    {caricamento2 === 'Caricamento in corso...' &&
                        <RotatingLines strokeColor='red' strokeWidth='5' animationDuration='5' width='26' />
                    }
                </div><br /><br />

                {/* ----------------------- Aggiungi video ------------------- */}
                <div>
                    <h4 style={{ marginTop: '0rem' }}>AGGIUNGI VIDEO (max 5 min)</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData.video &&
                            <div>
                                <div style={{ marginTop: '-27px' }}>
                                    <button style={{ marginLeft: '9rem', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>
                                <div>
                                    {/* ------------- preview del video proveniente da MYSQL ------------ */}
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData.video}`} id={'videoPreview'}
                                        style={{ width: '197px', height: '128px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>

                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {msgProgress.string && <p style={{ color: 'red', margin: '0 0 0 1em' }}><i>{msgProgress.string}</i></p>}
                </div>

                <hr />
                {msgProgress.submit &&
                    <p>{msgProgress.submit}<RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' /></p>
                }
                <p className='mt-5'><i>* campi obbligatori</i></p>
                <div className='mt-2'>
                    <button className='btn btn-secondary' onClick={() => {
                        navigate('/profiloRistorante', { replace: true })
                    }}>Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '2rem' }}>Avanti</button>
                </div>
            </form>
        </div>
        {/* ---------------- BANNER SUCCESS EDIT ------------------ */}
        <div ref={divSuccess} style={{
            backgroundColor: 'whitesmoke', border: '2px solid lightgrey', width: '100%', height: '100%', position: 'fixed',
            top: '0', left: '0', right: '0', padding: '3px', zIndex: '1', display: 'none', overflowY: 'auto'
        }}>
            <div className='bodyPadding'>
                <p style={{ backgroundColor: 'dodgerblue' }} className='mt-3 text-light fs-4 p-2'>
                    Ristorante modificato con successo
                </p>

                <p className='mt-5'>Il tuo ristorante <i>{risto.nome}</i> è stato modificato con successo !</p>
                <div style={{ display: 'grid', gridTemplateColumns: '.1fr 1fr', gap: '10px', margin: '3em 0 0 0' }}>
                    <div>INDIRIZZO</div> <div>{formData.indirizzo}</div>
                    <div>CITTA'</div> <div>{formData.comune} {formData.città}</div>
                    <div>DESCRIZIONE</div> <div>{formData.descrizione}</div>
                </div>
                {formData.email &&
                    <div style={{ display: 'grid', gridTemplateColumns: '.1fr 1fr', gap: '10px', marginTop: '3em' }}>
                        <div>
                            <img src={require('../../../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width={30} alt='' />
                        </div>
                        <div>{formData.email}</div>
                    </div>
                }
                {formData.tipoCucina.length !== 0 &&
                    <div style={{ display: 'grid', gridTemplateColumns: '.1fr 1fr', gap: '10px' }}>
                        <div>
                            <img src={require('../../../userNotAuth/image/icons8-cucina-48.png')} width={30} alt='' />
                        </div>
                        <div>{formData.tipoCucina.toString()}</div>
                    </div>
                }
                <hr />
                <div className='mt-5 mb-5'>
                    <button className='btn btn-primary ms-5' onClick={() => { navigate('/profiloRistorante') }}>Profilo Ristorante</button>
                    <button className='btn btn-secondary ms-5' onClick={() => { navigate('/') }}>Home</button>
                </div>
            </div>
        </div>
        <DivBottom />
    </>)
}
export default EditRisto